<template>
  <div class="card h-100">
    <div class="card-content is-hidden-tablet is-hidden-desktop is-position-relative">
      <router-link :to="{path:`/blog/${blog.id}/${blog.slug}`,params:{id: blog.id}}">
        <div class="has-text-weight-bold has-text-grey-dark line-height-medium is-size-5 mb-2">{{blog.title}}</div>
      </router-link>
      <div>
        <div ref="blogPreview" class="mt-1 is-text-overflow-3-lines line-height-medium" :class="{'height-3em': enabledSeeMore}" :style="{display: seeMore ? 'unset': '-webkit-box'}">
          <p @click="goToBlogPage">{{blog.blurb}}</p>
        </div>
        <div class="has-text-grey is-italic has-text-right font-size-16 blog-date-mobile" :class="{'is-hidden': !seeMore && enabledSeeMore}" @click="goToBlogPage">{{getBlogDate()}}</div>
        <div v-if="!seeMore && enabledSeeMore" class="has-text-grey see-more" @click="seeMore=true">...see more</div>
      </div>
    </div>
    <router-link :to="{path:`/blog/${blog.id}/${blog.slug}`,params:{id: blog.id}}">
      <div class="is-flex">
        <div class="card-image">
          <figure class="image is-4by3">
            <img :src="blog.cover_image" alt="Placeholder image" style="object-fit: cover;" loading="lazy">
          </figure>
        </div>
        <div class="card-content is-hidden-mobile">
          <div class="title is-5 has-text-weight-bold has-text-grey-dark line-height-medium mb-3">{{blog.title}}</div>
          <div class="has-text-grey line-height-medium mr-2">{{blog.blurb}}</div>
        </div>
      </div>
    </router-link>
  </div>
</template>
<script>
import commonMixin from "@/mixins/commonMixin";
export default {
    name: 'Blog',
    props: {
      blog: {
        type: Object,
        require: true
      }
    },
    mixins: [commonMixin],
    data: function () {
        return {
            seeMore: false,
            enabledSeeMore: false
        }
    },
    mounted() {
      const el = this.$refs.blogPreview
      this.enabledSeeMore = el.clientHeight + 10 < el.scrollHeight
    },
    methods: {
      getBlogDate() {
        return this.blog.published_date 
        ? this.formatDateTime(this.blog.published_date)
        : this.formatDateTime(this.blog.created_at)
      },
      goToBlogPage() {
        this.$router.push({ path:`/blog/${this.blog.id}/${this.blog.slug}`, params: { id: this.blog.id } })
      }
    }
}
</script>
<style scoped lang="scss">
.card {
  &-image {
    width: 25%;
    .image {
      height: 100%;
      img { 
        object-fit: fill !important;
      }
    }
  }
  &-content {
    width: 75%;
  }
}

@media (max-width: 767px) {
  .card {
    &-image {
      width: 100%;
    }
    &-content {
      width: 100%;
      padding: 1rem;
    }
  }
  .blog-date-mobile {
    position: relative;
    bottom: 0;
    right: 0;
  }
  .image.is-4by3 img {
    object-fit: cover !important;
  }
}
</style>